import { useState } from "react";
import { Card, ConfirmDialog, Spinner } from "../../shared/ui/index.js";
import { useToast } from "../../shared/toast.js";
import { useEventQr, useRegenerateQr } from "./events.api.js";

export function QrPanel({ eventId }: { eventId: string }) {
  const qr = useEventQr(eventId);
  const regen = useRegenerateQr(eventId);
  const toast = useToast();
  const [copied, setCopied] = useState(false);
  const [confirm, setConfirm] = useState(false);

  return (
    <Card id="qr" className="flex flex-col items-center gap-4 text-center">
      <h2 className="font-serif text-lg">QR code invité</h2>
      <p className="-mt-2 text-xs text-stone-400">
        Stable : imprimez-le une fois, il reste valable.
      </p>
      {qr.data ? (
        <>
          <img src={qr.data.qrDataUrl} alt="QR code" className="h-56 w-56" />
          <div className="flex flex-wrap justify-center gap-2">
            <a
              href={qr.data.guestUrl}
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-stone-300 px-4 py-2 text-sm"
            >
              Ouvrir le lien ↗
            </a>
            <button
              onClick={() => {
                navigator.clipboard.writeText(qr.data!.guestUrl);
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
              }}
              className="rounded-full border border-stone-300 px-4 py-2 text-sm"
            >
              {copied ? "Lien copié ✓" : "Copier le lien"}
            </button>
            <a
              href={qr.data.qrDataUrl}
              download={`qr-${eventId}.png`}
              className="rounded-full border border-stone-300 px-4 py-2 text-sm"
            >
              Télécharger le PNG
            </a>
          </div>
          <button
            onClick={() => setConfirm(true)}
            className="text-xs text-rose-600 underline"
          >
            Régénérer le QR (invalide les anciens)
          </button>
        </>
      ) : (
        <Spinner />
      )}

      {confirm && (
        <ConfirmDialog
          title="Régénérer le QR code ?"
          body="Tous les liens et QR codes déjà partagés ou imprimés cesseront de fonctionner. Un nouveau QR sera généré."
          confirmLabel="Régénérer"
          onConfirm={() =>
            regen.mutate(undefined, { onSuccess: () => toast("Nouveau QR généré") })
          }
          onClose={() => setConfirm(false)}
        />
      )}
    </Card>
  );
}
